// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n.SurveyHeader{\n\theight:auto;\n\tpadding-top:5px !important;\n\tpadding-bottom:5px !important;\n\theight:-moz-fit-content !important;\n\theight:fit-content !important;\n\tmargin-top:-50px;\n}\n", ""]);
// Exports
module.exports = exports;
